(function () {
  'use strict';

  /* ── Sort select ── */
  document.querySelectorAll('[data-q-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      window.location.href = url.toString();
    });
  });

  /* ── Load more — fetch next page, append cells, replace pagination ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-q-loadmore]');
    if (!btn) return;
    e.preventDefault();
    var nextUrl = btn.getAttribute('data-next-url');
    if (!nextUrl) return;

    var label = btn.textContent;
    btn.textContent = 'Loading…';
    btn.style.pointerEvents = 'none';

    fetch(nextUrl, { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc     = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('.q-grid');
        var newPag  = doc.querySelector('.q-pagination');
        var grid    = document.querySelector('.q-grid');
        var pag     = document.querySelector('.q-pagination');

        if (newGrid && grid) {
          newGrid.querySelectorAll('.q-grid__cell:not(.q-grid__cell--banner)')
            .forEach(function (cell) { grid.appendChild(cell); });
        }
        if (newPag && pag) {
          pag.replaceWith(newPag);
        } else if (pag) {
          btn.textContent = label;
          btn.style.pointerEvents = '';
        }
      })
      .catch(function () {
        btn.textContent = label;
        btn.style.pointerEvents = '';
      });
  });

  /* ── Wishlist toggle stub ──
     Fire custom event so wishlist app (Wishlist Plus / Swym / Growave)
     can intercept. Toggle aria-pressed for optimistic UI.
  ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    var pressed = btn.getAttribute('aria-pressed') === 'true';
    btn.setAttribute('aria-pressed', String(!pressed));
    btn.textContent = pressed ? '♡' : '♥';
    document.dispatchEvent(new CustomEvent('qulani:wishlist:toggle', {
      detail: { productId: btn.dataset.wishlistProductId, added: !pressed }
    }));
  });
})();
